/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useState, useEffect } from 'react';

import { Container, InputStyled, WrapperOptions } from './styles';

function InputSearch({
  initialTerm, options, placeholder, onSelected,
}) {
  const [searchTerm, setSearchTerm] = useState(initialTerm || '');
  const [isOpenOptions, setIsOpenOptions] = useState(false);
  const [searchResults, setSearchResults] = useState([]);

  useEffect(() => {
    if (searchTerm) {
      setSearchResults(
        options.filter(opt => opt.name.toLowerCase().includes(searchTerm.toLowerCase())),
      );
    } else {
      setSearchResults(options || []);
    }
  }, [searchTerm, options]);

  const handleClick = (option) => {
    setSearchTerm('');
    onSelected(option);
  };

  return (
    <Container>
      <InputStyled
        onFocus={() => setIsOpenOptions(true)}
        onFocusOut={() => setIsOpenOptions(false)}
        type="text"
        placeholder={placeholder || 'Adicionar'}
        value={searchTerm}
        onChange={e => setSearchTerm(e.target.value)}
      />
      {isOpenOptions && searchResults && searchResults.length > 0
      && (
      <WrapperOptions>
        {
        searchResults.map(option => (
          <li onClick={() => handleClick(option)}>{option.name}</li>
        ))}
      </WrapperOptions>
      )
    }
    </Container>
  );
}

export default InputSearch;
